import { combineReducers } from 'redux';

import serviceCalendarReducer from '../serviceCalendarSlice';
import serviceReducer from './serviceReducer';
import sessionReducer from './sessionReducer';
import vehicleReducer from './vehicleReducer';

const rootReducer = combineReducers({
    session: sessionReducer,
    vehicles: vehicleReducer,
    service: serviceReducer,
    serviceCalendar: serviceCalendarReducer
});

export default rootReducer;
